<template>
  <div
    class="min-w-[200px] sm:min-w-[240px] max-w-[240px] shrink-0 bg-white dark:bg-gray-700 border border-gray-100 dark:border-gray-600 rounded-lg shadow-sm p-3 flex flex-col h-[164px]"
  >
    <div class="flex items-start justify-between mb-2">
      <div class="h-5 w-16 bg-gray-200 dark:bg-gray-600 rounded shimmer"></div>
      <div class="h-5 w-5 bg-gray-200 dark:bg-gray-600 rounded shimmer"></div>
    </div>

    <div class="flex items-center gap-2 mb-2">
      <div class="w-10 h-10 bg-gray-200 dark:bg-gray-600 rounded-lg shimmer shrink-0"></div>
      <div class="min-w-0 flex-1 space-y-1">
        <div class="h-4 w-3/4 bg-gray-200 dark:bg-gray-600 rounded shimmer"></div>
        <div class="h-3 w-1/2 bg-gray-200 dark:bg-gray-600 rounded shimmer"></div>
      </div>
    </div>

    <div class="space-y-1 mb-2 flex-grow">
      <div class="h-3 w-2/3 bg-gray-200 dark:bg-gray-600 rounded shimmer"></div>
    </div>

    <div
      class="pt-2 border-t border-gray-100 dark:border-gray-600 flex items-center justify-between mt-auto"
    >
      <div class="h-3 w-16 bg-gray-200 dark:bg-gray-600 rounded shimmer"></div>
      <div class="h-5 w-20 bg-gray-200 dark:bg-gray-600 rounded shimmer"></div>
    </div>
  </div>
</template>

<style scoped>
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
.shimmer {
  background: linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 50%, #e5e7eb 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}
.dark .shimmer {
  background: linear-gradient(90deg, #4b5563 25%, #6b7280 50%, #4b5563 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}
</style>
